<div class="row pg-style">
  <div class="col-sm-12 pg-style">
    <div class="row search-banner">
      <div class="col-sm-12 search-banner-col">
        <h2 class="h3 search-banner-title">Reports</h2>
      </div>
    </div>
    <div class="row search-nav">
      <div class="col-sm-12 search-nav-col">
        <ul class="list-inline search-nav-list">
          @if (reportFeatures().includes('overageDependentNotice')) {
          <li>
            <div class="dropdown">
              <button type="button" class="dropbtn" [class.search-nav-active]="subHeader() !== 'customGroupReport'">Overage Dependent {{chosenReportAction()}} <i class="arrow down"></i></button>
              <div class="dropdown-content">
                <a (mousedown)="changeForm('Notice')">Dependent Notice</a>
                <a (mousedown)="changeForm('Term Consolidated Report')">Term Consolidated Report</a>
                <a (mousedown)="changeForm('Adhoc Report')">Adhoc Report</a>
              </div>
            </div>
          </li>
          }
          @if (reportFeatures().includes('customGroupReport')) {
          <li><a [class.search-nav-active]="subHeader() === 'customGroupReport'" (click)="toggle('customGroupReport')">Custom Group Report</a></li>
          }
        </ul>
      </div>
    </div>
    <div class="row report-component">
      <div class="col-sm-12 card">
        @if (subHeader() !== 'customGroupReport') {
        <app-overage-dependent [reportType]="chosenReportAction()"></app-overage-dependent>
        }
        @if (subHeader() === 'customGroupReport') {
        <bmt-custom-group-report></bmt-custom-group-report>
        }
      </div>
    </div>
  </div>
</div>
